const parseReports = function (reports) {
  if (!reports) {
    return []
  }

  for (let i = 0; i < reports.length; i++) {
    let report = reports[i]
    if (!report) {
      continue
    }
    let name = report.name
    if (!name) {
      continue
    }

    // remove star at the beginning
    name = name.replace(/^\*/, '')

    let labels = name.split(/\||\s-\s|\s--->\s|\s>\s/)
    report.labels = labels
    report.label = labels[labels.length - 1]
    report.parent = labels.slice(0, -1).join(' > ')
    if (typeof report._id === 'string') {
      report.href = `/audience/${report._id}/insights`
    } else if (report._id.audience_id) {
      report.href = `/audience/${report._id.audience_id}/insights`
    } else if (report._id.report_id) {
      report.href = `/report/${report._id.report_id}/insights`
    }
  }
  return reports
}

export default parseReports
